<template>
  <div class="data-management">
    <v-row no-gutters class="pr-0 mb-2">
      <v-col cols="12" class="pt-4">
        <div class="well-top-wrap">
          <h6>Samples</h6>
        </div>
        <TabularLoaders v-if="showLoader" :columns="3" :rows="8" />
        <v-table v-else-if="samples.length > 0" class="well-table sample-table fd-table fd-dm-asset-table">
          <thead>
            <tr class="main-header">
              <th>Sample ID</th>
              <th>Sample Type</th>
              <th>Tests</th>
            </tr>
          </thead>
          <tbody class="well-table-content">
            <tr v-for="(sample, index) in samples" :key="index">
              <td>
                <span class="clickable-cell no-bg" @click="goToSampleInformation(sample)">{{ sample.fluidSampleID }}</span>
              </td>
              <td>{{ sample.sampleType }}</td>
              <td>
                <div class="fd-dm-inline-row">
                  <template v-if="sampleHasTests(sample)">
                    <div class="sample-test-wrapper fd-dm-inline-chips">
                      <div v-for="(item, itemIndex) in comparisonArray" :key="item" class="sub-test-wrap" :class="{ 'has-test': sample[item] !== undefined }">
                        <template v-if="sample[item] !== undefined">
                          <template v-if="Array.isArray(sample[item])">
                            <div v-for="(test, testIndex) in testsForSampleType(sample, item)" :key="`${testIndex}-${itemIndex}`"
                              class="well-content sample-content"
                              @click="openTestPage(sample, item, testIndex, itemIndex)"
                            >
                              <div class="sample-test-div">
                                <img :src="test_image" alt="Panel Image" />
                              </div>
                              {{ displayTestType(item) }}
                              <template v-if="item === 'compositiontests'">
                                <span v-if="test.contaminationType === 'Physical'">(Physical)</span>
                                <span v-else-if="test.contaminationType === 'Mathematical'">(Mathematical)</span>
                                <span v-else-if="test.contaminationType">(Contaminated)</span>
                                <span v-else-if="test.recombinationType">(Uncontaminated)</span>
                              </template>
                              <span v-if="testsForSampleType(sample, item).length > 1" class="test-temperature">(Test # {{ testIndex + 1 }})</span>
                              <span class="test-temperature" v-if="test.testTemperature || test.testTemperature_UOM">
                                ({{ test.testTemperature }} {{ test.testTemperature_UOM }})
                              </span>
                            </div>
                          </template>
                          <div v-else class="well-content sample-content"
                            @click="openTestPage(sample, item, itemIndex)">
                            <div class="sample-test-div">
                              <img :src="test_image" alt="Panel Image" class="mr-2" width="20" height="20" />
                            </div>
                            {{ displayTestType(item) }}
                            <template v-if="item === 'compositiontests'">
                              <span v-if="sample[item].contaminationType === 'Physical'">(Physical)</span>
                              <span v-else-if="sample[item].contaminationType === 'Mathematical'">(Mathematical)</span>
                              <span v-else-if="sample[item].contaminationType">(Contaminated)</span>
                              <span v-else-if="sample[item].recombinationType">(Uncontaminated)</span>
                            </template>
                            <span class="test-temperature"
                              v-if="sample[item].testTemperature && sample[item].testTemperature_UOM">
                              ({{ sample[item].testTemperature }} {{ sample[item].testTemperature_UOM }})
                            </span>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div v-if="pdfLoaders[sample.ID]" class="pdf-div">
                      <img :src="pdf_loader_image" alt="loader Image" width="20" height="20" />
                    </div>
                    <div v-else class="pdf-btn" @click="goToPdf(sample)">
                      <img :src="pdf_icon" alt="pdf icon" />
                    </div>
                  </template>
                  <span v-else class="fd-dm-inline-empty">No test found.</span>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
        <div v-else-if="timeoutMessage != ''" class="no-asset-div timeout">
          <div class="text-center">
            {{ timeoutMessage }}
            <v-icon flat @click="fetchData()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
          </div>
        </div>
        <div class="no-asset-div" v-else-if="samples.length == 0 && showLoader == false && timeoutMessage == ''
        ">
          <h4>No sample(s) founds.</h4>
        </div>
      </v-col>
    </v-row>
    <ErrorPopup />
    <v-snackbar v-model="snackbarMessage" :color="snackbarColor" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import api from "../../../axiosInterceptor"
import { executeSampleReportDownload } from "../../../utils/sampleReportDownload";
import { getTenantPrefix } from "../../../utils/tenant";
import TabularLoaders from "../Loaders/TabularLoaders.vue";
import { mapActions } from "vuex";
import ErrorPopup from '../Popups/ErrorPopup.vue';
import { dedupeSampleTestArray } from "@/utils/sampleTestsList.js";

export default {
  name: "Sample",
  components: {
    TabularLoaders,
    ErrorPopup,
  },
  data() {
    return {
      samples: [],
      sampleIdString:'',
      sample_image: require("../../../assets/Images/Assets/wells.png"),
      test_image: require("../../../assets/Images/Assets/sample.png"),
      pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
      pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
      showLoader: true,
      showAllSamples: false,
      pdfLoaders: {},
      snackbarMessage: null,
      selectedSampleID: null,
      comparisonArray: [
        "compositiontests",
        "ccetests",
        "dltests",
        "cvdtests",
        "separatortests",
        "viscositytests",
      ],
      timeoutMessage: "",
    };
  },
  computed: {
    displayTestType() {
      return function (testType) {
        switch (testType) {
          case "compositiontests":
            return "Composition";
          case "ccetests":
            return "CCE Test";
          case "dltests":
            return "DL Test";
          case "cvdtests":
            return "CVD Test";
          case "separatortests":
            return "Separator Test";
          case "viscositytests":
            return "Viscosity Test";
          default:
            return testType;
        }
      };
    },
    filteredComparisonArray() {
      return this.comparisonArray?.filter(item => 
        this.sample[item] && (
          Array.isArray(this.sample[item]) ? this.sample[item].length > 0 : true
        )
      );
    },
    snackbarColor() {
      return this.$store.getters["darkMode/isDarkMode"] ? '#ef4444' : '#E53535';
    },

  },
  methods: {
    ...mapActions("test", ["setActiveTestIndex"]),
    ...mapActions("api", ["showSnackbar"]),
    testsForSampleType(sample, itemKey) {
      const raw = sample?.[itemKey];
      if (!Array.isArray(raw)) return raw ? [raw] : [];
      return dedupeSampleTestArray(raw);
    },
    fetchData(wellName,sampleId) {
      this.showLoader = true;
      this.timeoutMessage = "";
      const wellString = JSON.stringify(wellName);
      this.sampleIdString = JSON.stringify(sampleId);

      api
        .get(`public/api/samples`, {
          params: {
            well: wellString,
            viewSummary: true,
            id:this.sampleIdString
          },
        })
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            if (this.showAllSamples) {
              this.samples = response.data.data.samples;
            } else {
              this.samples = response.data.data.samples?.filter(
                (sample) => this.sampleHasTests(sample)
              );
            }
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching samples";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
      sampleHasTests(sample) {
        return sample.IsTestAvailable || (sample.compositiontests && sample.compositiontests.length > 0);
      },
    openTestPage(sample, item, index) {
      const filteredComparisonArray = this.comparisonArray?.filter(
        (comparisonItem) => sample.hasOwnProperty(comparisonItem)
      );

      let cumulativeIndex = 0;
      let itemIndex = -1;
      for (let i = 0; i < filteredComparisonArray.length; i++) {
        if (filteredComparisonArray[i] === item) {
          itemIndex = cumulativeIndex;
          break;
        }
        if (Array.isArray(sample[filteredComparisonArray[i]])) {
          cumulativeIndex += sample[filteredComparisonArray[i]].length;
        } else {
          cumulativeIndex++;
        }
      }

      this.setActiveTestIndex(itemIndex);
      const mongoSampleId = sample.ID;
      let testType = "";
      if (item != "compositiontests") {
         testType = item.endsWith("s") ? item.slice(0, -1) : item;
      }else{
         testType = item;
      }
      let testId;
      if (Array.isArray(sample[item])) {
        testId = sample[item][index].ID;
      } else {
        testId = sample[item].ID;
      }
      const tenant = getTenantPrefix();
      const asset = this.$route.params.asset;
      const field = this.$route.params.field;
      const well = this.$route.params.well;
      if (!tenant || !asset || !field || !well || !mongoSampleId || !testId) return;
      const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
      const newRoute = `/${tenant}/assets/${encodeSeg(asset)}/${encodeSeg(field)}/${encodeSeg(well)}/${encodeSeg(mongoSampleId)}/${testType}/${testId}`;
      localStorage.setItem("lastView", newRoute);
      this.$router.push(newRoute);
      
    },
    reportExtensionFromSample(sample) {
      const s = sample?.source;
      if (!s || typeof s !== "string" || s === "Synthetic Data" || !s.includes(".")) {
        return "pdf";
      }
      const lower = s.toLowerCase();
      if (lower.endsWith(".xlsm")) return "xlsm";
      if (lower.endsWith(".xlsx")) return "xlsx";
      if (lower.endsWith(".xls")) return "xls";
      if (lower.endsWith(".pdf")) return "pdf";
      return "pdf";
    },
    async goToPdf(sample) {
      this.snackbarMessage = null;
      this.pdfLoaders[sample.ID] = true;
      const sampleId = sample.ID;
      const ext = this.reportExtensionFromSample(sample);
      try {
        const result = await executeSampleReportDownload({
          extension: ext,
          httpGet: () =>
            api.get(`public/api/samples/${sampleId}/download`, {
              responseType: "blob",
            }),
        });
        if (!result.ok && !result.limitModal && result.snackbarMessage) {
          this.snackbarMessage = result.snackbarMessage;
        }
      } finally {
        this.pdfLoaders[sample.ID] = false;
      }
    },

    goToSampleInformation(sample) {
      const tenant = getTenantPrefix();
      const asset = this.$route.params.asset;
      const field = this.$route.params.field;
      const well = this.$route.params.well;
      const sampleId = sample.ID;
      if (!tenant || !asset || !field || !well || !sampleId) return;
      const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
      const newRoute = `/${tenant}/assets/${encodeSeg(asset)}/${encodeSeg(field)}/${encodeSeg(well)}/sampleinformation/${encodeSeg(sampleId)}`;
      localStorage.setItem("lastView", newRoute);
      this.$router.push(newRoute);
    },
  },
  watch: {
    $route(to, from) {
      this.fetchData(to.params.well,to.params.sampleId);
    },
    showAllSamples(value) {
      this.fetchData(this.$route.params.well,this.$route.params.sampleId);
    },
  },
  mounted() {
    this.fetchData(this.$route.params.well,this.$route.params.sampleId);
  },
};
</script>
